import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle } from '@fortawesome/pro-regular-svg-icons';
import {
  faCircleCheck,
  faCircleX,
} from '@fortawesome/pro-solid-svg-icons';
import OrderStatusDisplayType from '../../OrderStatusDisplayType';

function OrderShippingProgress({ orderStatusType }) {
  switch (orderStatusType) {
    case OrderStatusDisplayType.PARTIAL:
      return (
        <div className="row mb-3">
          <div className="col-auto pr-0">
            <FontAwesomeIcon icon={faCircle} className="text-success pl-3" size="2x" />
            <div className="pl-2">Partial</div>
          </div>
        </div>
      );
    case OrderStatusDisplayType.SHIPPED:
      return (
        <div className="row mb-3">
          <div className="col-auto pr-0">
            <FontAwesomeIcon icon={faCircleCheck} className="text-success pl-3" size="2x" />
            <div>Received</div>
          </div>
          <div className="col-1 mx-0 px-0"><hr className="border-dark" /></div>
          <div className="col-auto px-0">
            <FontAwesomeIcon icon={faCircleCheck} className="text-success pl-3" size="2x" />
            <div>Shipped</div>
          </div>
          <div className="col-1 mx-0 px-0"><hr className="border-dark" /></div>
          <div className="col-auto pl-0">
            <FontAwesomeIcon icon={faCircle} className="text-success pl-3" size="2x" />
            <div>Delivered</div>
          </div>
        </div>
      );
    case OrderStatusDisplayType.DELIVERED:
      return (
        <div className="row mb-3">
          <div className="col-auto pr-0">
            <FontAwesomeIcon icon={faCircleCheck} className="text-success pl-3" size="2x" />
            <div>Received</div>
          </div>
          <div className="col-1 mx-0 px-0"><hr className="border-dark" /></div>
          <div className="col-auto px-0">
            <FontAwesomeIcon icon={faCircleCheck} className="text-success pl-3" size="2x" />
            <div>Shipped</div>
          </div>
          <div className="col-1 mx-0 px-0"><hr className="border-dark" /></div>
          <div className="col-auto pl-0">
            <FontAwesomeIcon icon={faCircleCheck} className="text-success pl-3" size="2x" />
            <div>Delivered</div>
          </div>
        </div>
      );
    case OrderStatusDisplayType.RECEIVED:
    case OrderStatusDisplayType.HOLD:
      return (
        <div className="row mb-3">
          <div className="col-auto pr-0">
            <FontAwesomeIcon icon={faCircleCheck} className="text-success pl-3" size="2x" />
            <div>Received</div>
          </div>
          <div className="col-1 mx-0 px-0"><hr className="border-dark" /></div>
          <div className="col-auto px-0">
            <FontAwesomeIcon icon={faCircle} className="text-success pl-3" size="2x" />
            <div>Shipped</div>
          </div>
          <div className="col-1 mx-0 px-0"><hr className="border-dark" /></div>
          <div className="col-auto pl-0">
            <FontAwesomeIcon icon={faCircle} className="text-success pl-3" size="2x" />
            <div>Delivered</div>
          </div>
        </div>
      );
    case OrderStatusDisplayType.CANCELLED:
      return (
        <div className="row mb-3">
          <div className="col-auto">
            <FontAwesomeIcon icon={faCircleX} className="text-warning pl-3" size="2x" />
            <div>Cancelled</div>
          </div>
        </div>
      );
    case OrderStatusDisplayType.COMPLETED:
      return (
        <div className="row mb-3">
          <div className="col-auto">
            <FontAwesomeIcon icon={faCircleCheck} className="text-success pl-3" size="2x" />
            <div>Complete</div>
          </div>
        </div>
      );
    default:
      return (<div> - </div>);
  }
}

OrderShippingProgress.propTypes = {
  orderStatusType: PropTypes.number.isRequired,
};

export default OrderShippingProgress;
